import React from 'react';
import NewVS from './NewVS';
import {
  biYearlyTotalPrice,
  initialValues,
  totalPrice,
  triYearlyTotalPrice,
  validationSchema,
  yearlyTotalPrice,
} from './util';
import { Formik } from 'formik';
import { addVS_CART } from 'store/actions/vs-shopping-cart';
import { useDispatch, useSelector } from 'react-redux';
import Loading from 'components/common/loading';
import { useQuery } from 'react-query';

const NewVSContainer = () => {
  const dispatch = useDispatch();
  const { data: regionsData, isLoading: regionLoading } = useQuery('/public/checkout/vs/regions');
  const cartVs = useSelector((state) => state.vsCart.vs_deploy);
  const handleSubmit = (values, setSubmitting) => {
    let price = totalPrice(values);
    let yearly_price = yearlyTotalPrice(values);
    let bi_yearly_price = biYearlyTotalPrice(values);
    let tri_yearly_price = triYearlyTotalPrice(values);
    let { selected_region, selected_size, app, selected_image, term, backup } = values;
    let vs_cart = {
      tri_yearly_price,
      bi_yearly_price,
      selected_region,
      selected_size,
      app,
      selected_image,
      price,
      yearly_price,
      term,
      backup,
    };
    dispatch(addVS_CART({ vs_cart }));
    localStorage.setItem('vs_cart', JSON.stringify([...cartVs, { ...vs_cart }]));
    setTimeout(() => {
      setSubmitting(false);
    }, 0.5 * 1000);
  };

  if (regionLoading) {
    return <Loading gap={200} />;
  }
  return (
    <Formik
      initialValues={initialValues(regionsData?.regions)}
      validationSchema={validationSchema}
      onSubmit={(values, { setSubmitting }) => handleSubmit(values, setSubmitting)}
    >
      {(formikProp) => <NewVS regionLoading={regionLoading} regionsData={regionsData} formikProp={formikProp} />}
    </Formik>
  );
};
export default NewVSContainer;
